/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState, useMemo} from 'react';
import { DropzoneDialogBase } from 'material-ui-dropzone';

import { useHistory } from 'react-router-dom';

import {
    makeStyles, 
    Theme, 
    Container, 
    Grid, 
    Button,
    MenuItem,
    TextField,
    IconButton,    
    Dialog, 
    DialogActions, 
    DialogContent,
    DialogContentText, 
    DialogTitle,
} from '@material-ui/core';

import { embedDashboard } from 'amazon-quicksight-embedding-sdk';

import { AppContext } from '../stores/AppStore';
import { UserContext } from '../stores/UserStore';
import { SecurityContext } from '../stores/SecurityStore';

import LoadingOverlay from '../components/common/LoadingOverlay';

import DeleteIcon from '../assets/images/delete.svg';
import EditIcon from '../assets/images/edit.svg';
import MobileIcon from '../assets/images/mobile.svg';
import DesktopIcon from '../assets/images/desktop.svg';
import ArrowRightIcon from '../assets/images/arrow-right.svg';
import CancelIcon from '@material-ui/icons/Cancel';

import UnknowUserImg from '../assets/images/unknow-user.svg';
import LogoImg from '../assets/images/logo-manage-user.svg';


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(2,2,0,2),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        alignItems: 'stretch',
        height: '92vh'
    },
    header: {
        backgroundColor: 'transparent',
        flex: '50px 0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '10px'
    },
    toolbar: {
        // margin: 2
    },    
    body: {
        backgroundColor: theme.palette.secondary.main,
        flex: '1 0',
        borderRadius: '8px 8px 0 0',
        justifyContent: 'center',        
        alignItems: 'flex-start',
        alignContent: 'flex-start'
    },
    bodyReport: {
        backgroundColor: theme.palette.secondary.main,
        flex: '1 0',
        borderRadius: '8px 8px 0 0',
        justifyContent: 'stretch',        
        alignItems: 'stretch'
    },
    gradientButton: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.text.primary,
        height: 32,
        borderRadius: '4px',
        background: 'linear-gradient(136.14deg, #009EE0 0%, #172983 100%)',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.14)',
        textTransform: 'none' 
    },
    viewButton: {
        height: 26,
        width: 70,
        fontSize: 12,
        fontWeight: 500,
        backgroundColor: '#F8F9FA',
        color: theme.palette.primary.main,
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.14)',
        textTransform: 'none' 
    },
    title: {
        fontSize: 24,
        fontWeight: 700,
        marginRight: 16,
    },
    card: {
        minHeight: 325,
        maxHeight: 325,
        minWidth: 310,
        maxWidth: 310,
        margin: theme.spacing(3,2),
        borderRadius: '8px',
        backgroundColor: '#000000',
        boxShadow: '0 8px 16px 0 rgba(0,0,0,0.14)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        alignItems: 'stretch'
    },
    cardHeader: {
        flex: '24px 0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: 16,
        fontWeight: 600,
        margin: theme.spacing(1, 1, 0, 1)
    },
    cardAlert: {
        backgroundColor: theme.palette.info.main,
        borderRadius: '8px 8px 0 0',
        flex: '24px 0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: 14,
        fontWeight: 100,
        margin: theme.spacing(0),
        padding:  theme.spacing(1)
    },
    cardIcon: {
        height: 22,
        margin: theme.spacing(0.5),
        cursor: 'pointer'        
    },
    cardBody: {
        flex: '1 0',
        display: 'flex',
        flexDirection: 'column', 
    },    
    cardContainer: {
        display: 'flex',
        flexDirection: 'row',        
        justifyContent: 'stretch',
        alignItems: 'stretch',        
        margin: theme.spacing(0),        
    },    
    cardConnection: {
        flex: '1 0',
        display: 'flex',
        borderRadius: '4px',
        minHeight: 58,
        flexDirection: 'column',        
        margin: theme.spacing(1),        
        backgroundColor: '#F8F9FA',
        fontSize: 12,
        fontWeight: 500,
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.secondary.main,
    },    
    cardManage: {
        flex: '1 0',
        display: 'flex',
        borderRadius: '4px',
        height: 38,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',                
        margin: theme.spacing(1),    
        padding: theme.spacing(1),    
        backgroundColor: '#F8F9FA',
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.primary.main,
        cursor: 'pointer'
    },    
    cardFooter: {
        flex: '28px 0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: theme.spacing(1)
    },
    dialogRoot: {
        '& .MuiPaper-root': {
            backgroundColor: theme.palette.text.primary,
        }
    },
    dialogTitle: {
        padding: '10px 24px 0px 24px',
        color: '#000000'
    },
    dialogContent: {
        minHeight: '75vh',
        '& .MuiDialogContentText-root': {
            fontSize: 16,
            color: '#00000094',
            lineHeight: 1
        }
    },
    dialogCloseButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.primary.main,
    },
    dialogActions: {
        '& .MuiButton-contained.Mui-disabled': {
            color: theme.palette.grey[300],
            border: '1px solid' 
        }
    },
    cardContent: {
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',   
        flexWrap: 'wrap'
    },
    cardContentUser: {
        flex: '1 0',
        margin: theme.spacing(0),
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'stretch',
        alignItems: 'flex-start',
    },
    cardContentUserData: {
        flex: '1 0',
        margin: theme.spacing(1,3),
        borderRadius: '8px',
        backgroundColor: '#F8F9FA',
        color: theme.palette.text.secondary,
        // boxShadow: '0 8px 16px 0 rgba(0,0,0,0.14)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        minHeight: '73vh'
    },    
    cardUser: {
        margin: theme.spacing(1),        
        minHeight: '224px',
        width: '245px',
        borderRadius: '8px',
        backgroundColor: '#F8F9FA',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start'
    },
    cardUserPicture: {
        margin: theme.spacing(1),
        height: '80px',
        width: '80px',
        borderRadius: '100px',
        backgroundColor: theme.palette.text.primary
    },
    cardUserName: {
        color: '#666666',
        fontSize: '14px',
        fontWeight: 500        
    },    
    cardViewUserInfo: {
        maxHeight: '24px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',                
        margin: theme.spacing(1),    
        padding: theme.spacing(0),    
        backgroundColor: '#F8F9FA',
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.primary.main,
        cursor: 'pointer'
    },    
    cardDenyUser: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        color: '#666666',
        width: '90%',
        alignItems: 'center',                
        margin: theme.spacing(0,2),    
    },
    cardItem: {
        width:  'calc(100% - 20px)',
        margin: theme.spacing(0,1,2),
        fontSize: 12,
        '& .MuiFormLabel-root': {
            color: '#666666'
        },
        '& .MuiInput-root': {
            // color: theme.palette.primary.main,
            color: '#000000',
            '& .MuiInputBase-input': {
                paddingLeft: '10px',
                backgroundColor: '#FFFFFF',
                height: '1.8em',
                borderRadius: '4px',
                boxShadow: 'inset 0 1px 3px 0 rgba(0,0,0,0.14)'
            },
            '& .MuiSelect-select.MuiSelect-select': {
                paddingTop: '10px',
                paddingBottom: '0px'
            },
            '& .Mui-disabled': {
                opacity: 0.5
            }                
        }
    },
    cardSetProfile: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: theme.palette.text.primary,
        color: '#666666',
        width:  'calc(100% - 20px)',
        height: '90px',
        margin: theme.spacing(0,0,2),
        borderRadius: '4px'
    },
    cardPicture: {
        margin: theme.spacing(3),
        height: '160px',
        width: '160px',
        boxShadow: '0 3px 5px 0 rgba(0,0,0,0.14)',
        borderRadius: '100px',
        backgroundColor: theme.palette.text.primary
    },
    cardRow: {
        margin: theme.spacing(2),
        display: 'flex', 
        flexDirection: 'row'
    },
    cardTitle: {
        width:  'calc(100% - 20px)',
        margin: theme.spacing(0,1),
        fontSize: 20,
        fontWeight: 300,
        color: '#666666'
    },
    cardApp: {
        width:  'calc(100% - 20px)',
        margin: theme.spacing(0,1),
        paddingBottom: theme.spacing(2),
        fontSize: 20,
        fontWeight: 300,
        color: '#666666',
        borderRadius: '8px',
        backgroundColor: '#FFFFFF'        
    },
    cardOtherApp: {
        width:  'calc(100% - 20px)',
        margin: theme.spacing(0,1),
        paddingBottom: theme.spacing(0),
        fontSize: 14,
        fontWeight: 300,
        color: '#000000',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start'         
    }    
    
}));



const Home = () => {
    const history = useHistory();
    const classes = useStyles();
    const { showSuccessMessage, showErrorMessage, applicationSearchText, setApplicationSearchText, transformFileToBase64 } = useContext(AppContext);
    const { currentUser } = useContext(UserContext);
    const { dashboardData, getDashboardData, getRequestUserData, getUserPicture, uploadUserPicture, applyUserData, getReport } = useContext(SecurityContext);
    
    const [isLoading, setLoading] = useState(true);
    const [requestNewUserList, setRequestNewUserList] = useState(null);
    const [requestNewUser, setRequestNewUser] = useState(null);
    const [currentApp, setCurrentApp] = useState(null);
    const [countPicture, setCountPicture] = useState(0);
    const [openPictureDialog, setOpenPictureDialog] = useState(false);
    const [pictureObjects, setPictureObjects] = useState([]);
    const [view, setView] = useState('Reports');

    useEffect(() =>  {
        if (applicationSearchText) {
            setApplicationSearchText('');
            history.push('/search/users/'+applicationSearchText);
        }
    }, [applicationSearchText]);

    useEffect(() =>  {
        init();
    }, []);

    const init = async () => {
        setLoading(true);
        getDashboardData().catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setLoading(false);            
        });
    };


    useEffect(() =>  {
        if (requestNewUserList) {
            for (const user of requestNewUserList) {
                if (!user.isLoadPicture) {
                    user.isLoadPicture = true;
                    user.picture = null;
                    getUserPicture(user.id).then(response => {
                        user.picture = response;
                        setTimeout(() => {
                            setCountPicture(countPicture+1);                    
                        }, 1500);
                    }).catch(errorMessage => {
                        console.error(errorMessage);                    
                    });              
                }
            }    
        }
    }, [requestNewUserList]);

    useEffect(() =>  {
        if (view === 'Dashboard') {
            setLoading(true);
            getReport(process.env.REACT_APP_QUICK_SIGHT_REPORT_ID).then(report => {
                const options = {
                    container: document.getElementById("quicksightEmbed"),
                    url: report.url,
                    locale: 'en-US',
                    height: '100%',
                    width: '100%'
                }
                embedDashboard(options);            
            }).catch(errorMessage => {
                showErrorMessage(errorMessage);;                    
            }).finally(() => {
                setLoading(false);            
            });
        }
    }, [view]);

    const handleView = () => {
        if (view === 'Dashboard') {
            setView('Reports');
        } else {
            setView('Dashboard');
        }
    };

    const handleProfiles = () => {
        history.push('/profiles');
    };

    const handleServices = () => {
        history.push('/services');
    };

    const handleUsers = () => {
        history.push('/users');
    };

    const handleApplications = () => {
        history.push('/applications');
    };

    const handleEditApplication = (appId) => () => {
        history.push('/applications/edit/'+appId);
    };

    const handleDeleteApplication = (appId) => () => {
        history.push('/applications/delete/'+appId);
    };
       
    const handleManageUsers = (appId) => () => {
        history.push('/manage/users/'+appId);
    };    

    const handleManageProfiles = (appId) => () => {
        history.push('/manage/profiles/'+appId);
    };    
    
    const handleRequestNewUser = (app) => async () => {
        setLoading(true);
        setCurrentApp(app);

        try {
            const list = await getRequestUserData(app.id, app.newUserRequests);
            if (list.length === 1) {
                const data = list[0];
                data.deny = data.deny === undefined ? false : data.deny;
                data.oldProfileId = data.profileId; 
                data.picture = await getUserPicture(data.id);
                setRequestNewUser(data);    
            } else {
                const newList = [];
                for (const data of list) {
                    data.isLoadPicture = false;
                    data.deny = data.deny === undefined ? false : data.deny;
                    data.oldProfileId = data.profileId; 
                    data.profileId = ''; 
                    newList.push(data);
                }
                setRequestNewUserList(newList);
            }
        } catch (errorMessage) {
            showErrorMessage(errorMessage);
        }
        setLoading(false);
    };
    
    const handleRequestNewUserListClose = () => {
        setRequestNewUser(null);
        setRequestNewUserList(null);
    };
    
    const handleRequestNewUserListDenyAll = async() => {
        const data = [...requestNewUserList];
        for (const req of data) {
            req.deny = true;
            req.modified = true;
        }
        setRequestNewUserList(data);
    };

    const handleRequestNewUserListApply = async () => {
        try {
            setLoading(true);
            const data = [];
            const list = [];
            for (const req of requestNewUserList) {
                if (req.modified) {
                    data.push({ 
                        applicationId: currentApp.id, 
                        id: req.id, 
                        profileId: req.profileId,
                        oldProfileId: req.oldProfileId,
                        deny: req.deny 
                    });                   
                } else {
                    list.push(req);
                }
            }
            await applyUserData(data);
            
            showSuccessMessage('Users upadated success!');
            setRequestNewUser(null);
        
            if (list.length === 0) {
                setRequestNewUserList(null);
                await init();        
            } else {
                setRequestNewUserList(list);
            }

        } catch (errorMessage) {
            showErrorMessage(errorMessage);
        } finally {
            setLoading(false);
        }        
    };    

    const handleRequestNewUserClose = () => {
        setRequestNewUser(null);
    };

    const handleRequestNewUserDeny = async() => {
        try {
            setLoading(true);
            
            const data = [
                {
                    id: requestNewUser.id,
                    profileId: requestNewUser.profileId,
                    applicationId: currentApp.id,
                    deny: true 
                }
            ];
            
            await applyUserData(data);
            
            if (requestNewUserList) {
                const newList = [...requestNewUserList];
                const userIndex = newList.findIndex(x => x.id === requestNewUser.id);
                newList.splice(userIndex, 1);
                setRequestNewUserList(newList);
            }

            await init();                

            showSuccessMessage('User updated!');
            setRequestNewUser(null);
        } catch (errorMessage) {
            showErrorMessage(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleRequestNewUserApply = async () => {
        try {            
            setLoading(true);
            const profileId = requestNewUser.profiles.filter(profile => profile.applicationId === currentApp.id)[0].id;
            
            if (requestNewUser.isChangePicture && requestNewUser.picture) {
                await uploadUserPicture(requestNewUser.id, requestNewUser.picture);
            }          
                      
            const data = [
                {
                    applicationId: currentApp.id,
                    id: requestNewUser.id,
                    profileId: profileId,
                    oldProfileId: requestNewUser.oldProfileId,
                    deny: false,
                    saveData: {
                        firstName: requestNewUser.firstName,
                        lastName: requestNewUser.lastName,
                        phoneNumber: requestNewUser.phoneNumber,
                        position: requestNewUser.position,
                        company: requestNewUser.company,
                        language: requestNewUser.language,
                        country: requestNewUser.country
                    }          
                }
            ];
            
            await applyUserData(data);

            if (requestNewUserList) {
                const newList = [...requestNewUserList];
                const userIndex = newList.findIndex(x => x.id === requestNewUser.id);
                newList.splice(userIndex, 1);
                setRequestNewUserList(newList);
            }

            await init();                

            showSuccessMessage('User updated!');
            setRequestNewUser(null);
        } catch (errorMessage) {
            showErrorMessage(errorMessage);
        } finally {
            setLoading(false);
        }
    };    

    const handleViewActivity = (appId) => () => {
        history.push('/view-activity/'+appId);
    };

    const handleViewUserInformation = (user) => () => {
        const record = {...user};
        setRequestNewUser(record);
    };

    const handleDenyUser = (user) => () => {
        const newList = [...requestNewUserList];
        const userlist = newList.find(x => x.id === user.id);
        userlist.deny = userlist.deny === undefined ? true : !userlist.deny;
        userlist.modified = userlist.deny; 
        setRequestNewUserList(newList);
    };

    const handleProfileChange = (user) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const newList = [...requestNewUserList];
        const userlist = newList.find(x => x.id === user.id);
        userlist.profileId = event.target.value;
        userlist.modified = true;  
        setRequestNewUserList(newList);
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const record = {...requestNewUser};
        record[event.target.name] = event.target.value;
        setRequestNewUser(record);
    };
    
    const handleProfileInputChange = (profile) => (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const data = {...requestNewUser};   
        const newProfile = dashboardData.find(app => app.id === profile.applicationId).profiles.find(profile => profile.id === event.target.value);
        const newProfiles = [];
        for (let p of requestNewUser.profiles) {
            if (p.id === profile.id) {
                newProfiles.push(newProfile);
            } else {
                newProfiles.push(p);
            }
        }
        data.profiles = newProfiles;
        setRequestNewUser(data);
    };     

    const handleUploadUserPicture = () => {
        const file = pictureObjects[0].file;
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
    
        reader.onload = (e: ProgressEvent) => {
            const byteArray = (e.target as FileReader).result;
            const base64 = transformFileToBase64(byteArray);

            const record = {...requestNewUser};
            record.picture = 'data:' + file.type + ';base64, ' + base64;
            record.isChangePicture = true;
            setRequestNewUser(record);                
            setOpenPictureDialog(false);   
        };                                
    }
    

    const renderReport = useMemo(() => <Grid container spacing={0} className={classes.bodyReport}>
        <div id="quicksightEmbed" style={{flex: '1 0'}}></div>
    </Grid>, [view, isLoading]);    

    const renderDashboard = useMemo(() => <Grid container spacing={0} className={classes.body}>
        { dashboardData.map( app => { return   <Grid key={app.id} item>
            <div className={classes.card}>
                { app.newUserRequests && app.newUserRequests.length > 0 && <div className={classes.cardAlert}>
                    <span style={{fontSize: '18px', fontWeight: 500}}>New User Request</span>
                    <Button variant="contained" className={classes.viewButton} onClick={handleRequestNewUser(app)} >
                        View
                    </Button>                        
                </div> }
                <div className={classes.cardHeader}>
                    <span>{app.name}</span>
                    <div>
                        { app.isMobile && <img className={classes.cardIcon} src={MobileIcon} alt="Mobile"/> }
                        { app.isWeb && <img className={classes.cardIcon} src={DesktopIcon} alt="Desktop"/> }
                    </div>
                </div>
                <div className={classes.cardBody}>
                    <div className={classes.cardContainer}>
                        <div className={classes.cardConnection}>
                            <span>USERS</span>
                            <div>
                                <span style={{fontSize: 24}}>{app.users.count} /</span>
                                <span>{app.users.total}</span>
                            </div>
                        </div>                            
                        <div className={classes.cardConnection}>
                            <span>CONNECTIONS</span>
                            <span style={{fontSize: 24}}>{app.connections.total}</span>
                        </div>                            
                    </div>                            
                    <div className={classes.cardContainer}>
                        <div className={classes.cardManage} onClick={handleManageUsers(app.id)}>
                            <span>Manage Users</span>
                            <span><img className={classes.cardIcon} src={ArrowRightIcon} alt="Go"/></span>
                        </div>                            
                    </div>                            
                    <div className={classes.cardContainer}>
                        <div className={classes.cardManage} onClick={handleManageProfiles(app.id)}>
                            <span>Manage Profiles</span>
                            <span><img className={classes.cardIcon} src={ArrowRightIcon} alt="Go"/></span>
                        </div>                            
                    </div>                            
                </div>
                <div className={classes.cardFooter}>
                    <div>
                        { currentUser?.roles?.APPLICATION?.SAVE_RECORD && <img className={classes.cardIcon} src={EditIcon} alt="Edit" onClick={handleEditApplication(app.id)}/> }
                        { currentUser?.roles?.APPLICATION?.REMOVE_RECORD && <img className={classes.cardIcon} src={DeleteIcon} alt="Delete" onClick={handleDeleteApplication(app.id)}/> }
                    </div>
                    <Button variant="contained" className={classes.gradientButton} style={{fontSize: 12, width: 115}} onClick={handleViewActivity(app.id)} >
                        View Activity
                    </Button>
                </div>
                
            </div>
            
        </Grid>})}
    </Grid>, [dashboardData, view, isLoading]);    


    const renderRequestNewUserList = useMemo(() => requestNewUserList && <Dialog
        className={classes.dialogRoot}
        disableBackdropClick
        disableEscapeKeyDown            
        fullWidth
        maxWidth="xl"
        open={requestNewUserList !== null}
        aria-labelledby="request-list-dialog">
        <DialogTitle className={classes.dialogTitle} id="request-list-dialog">
            New User Requests

            <IconButton aria-label="close" className={classes.dialogCloseButton} onClick={handleRequestNewUserListClose}>
                <CancelIcon />
            </IconButton>

        </DialogTitle>
        <DialogContent dividers={false} className={classes.dialogContent}>
            <DialogContentText>Several new users request access to {currentApp && currentApp.name}</DialogContentText>
            <DialogContentText>Please, set a profile for these users or deny their requests.</DialogContentText>
            <div className={classes.cardContent}>
                { requestNewUserList.map( user => { return   <div key={user.id} className={classes.cardUser}>
                    <img src={user.picture || UnknowUserImg} className={classes.cardUserPicture} alt="User" />                
                    <span className={classes.cardUserName}>{user.firstName + ' ' + user.lastName}</span>
                        <div className={classes.cardViewUserInfo} onClick={handleViewUserInformation(user)}>
                            <span>VIEW USER INFORMATION</span>
                            <img className={classes.cardIcon} src={ArrowRightIcon} alt="Go"/>
                        </div>
                        { user.deny ? <div className={classes.cardSetProfile} style={{justifyContent: 'center'}}>
                            <span>Requested Denied</span>
                            <Button color="primary" onClick={handleDenyUser(user)} >
                                Modify
                            </Button>
                        </div> : <div className={classes.cardSetProfile}>                                                    
                            <div className={classes.cardDenyUser}>
                                <span>Set Profile</span>
                                <Button color="primary" onClick={handleDenyUser(user)} >
                                    Deny
                                </Button>
                            </div>
                            <TextField
                                select
                                required
                                placeholder="Select Profile"
                                className={classes.cardItem}
                                value={user.profileId}
                                onChange={handleProfileChange(user)}                            
                                fullWidth>
                                    {   
                                        currentApp && currentApp.profiles.map((appProfile) => (
                                            <MenuItem key={appProfile.id} value={appProfile.id}>
                                                {appProfile.label}                                                
                                            </MenuItem>
                                        ))                                                                            
                                    }
                            </TextField>
                        </div>}
                </div> })}                      
            </div>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
            <Button color="primary" style={{width: '100px'}} onClick={handleRequestNewUserListClose}>
                Close   
            </Button>
            <Button color="primary" style={{width: '100px'}} onClick={handleRequestNewUserListDenyAll}>
                Deny All
            </Button>
            <Button variant="contained" disabled={!requestNewUserList || requestNewUserList.filter( req => req.modified ).length === 0 } color="primary" style={{width: '100px'}} onClick={handleRequestNewUserListApply}>
                Apply
            </Button>
        </DialogActions>
    </Dialog>, [currentApp, requestNewUserList, isLoading, countPicture]);

    const renderRequestNewUser = useMemo(() => requestNewUser && <Dialog
        className={classes.dialogRoot}
        disableBackdropClick
        disableEscapeKeyDown            
        fullWidth
        maxWidth="xl"
        open={requestNewUser !== null}
        aria-labelledby="request-list-dialog">
        <DialogTitle className={classes.dialogTitle} id="request-list-dialog">
            New User Request

            <IconButton aria-label="close" className={classes.dialogCloseButton} onClick={handleRequestNewUserClose}>
                <CancelIcon />
            </IconButton>

        </DialogTitle>
        <DialogContent dividers={false} className={classes.dialogContent}>
            <DialogContentText>A new user request access to {currentApp && currentApp.name}</DialogContentText>
            <div className={classes.cardContentUser}>
                <div className={classes.cardContentUserData} style={{flex: '280px 0', alignItems: 'center', minHeight: '280px'}}>
                    <img src={requestNewUser.picture || UnknowUserImg} className={classes.cardPicture} alt="User" />
                    <Button color="primary" onClick={() => {
                        setPictureObjects([]);
                        setOpenPictureDialog(true);
                    }}>Change Picture</Button>
                </div>
                <div className={classes.cardContentUserData}>
                    <div className={classes.cardRow}>
                        <span className={classes.cardTitle}>User Information</span>
                        { requestNewUser.type === 'employee' && <img src={LogoImg} style={{width: '85x', height: '20px'}} alt="Logo" /> }
                    </div>

                    <div className={classes.cardRow}>
                        <TextField
                            label="First Name:"
                            required
                            placeholder="First Name"
                            id="firstName"
                            name="firstName"
                            className={classes.cardItem}
                            error={requestNewUser.firstName !== undefined && !requestNewUser.firstName}
                            value={requestNewUser.firstName}
                            onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            // variant="outlined"
                            InputLabelProps={{shrink: true}}
                            />
                        <TextField
                            label="Last Name:"
                            required
                            placeholder="Last Name"
                            id="lastName"
                            name="lastName"
                            className={classes.cardItem}
                            error={requestNewUser.lastName !== undefined && !requestNewUser.lastName}
                            value={requestNewUser.lastName}
                            onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            // variant="outlined"
                            InputLabelProps={{shrink: true}}
                            />
                    </div>
                    <div className={classes.cardRow}>
                        <TextField
                            label="Email:"
                            disabled
                            type="email"
                            placeholder="Email"
                            id="email"
                            name="email"
                            className={classes.cardItem}
                            // error={requestNewUser.email !== undefined && !requestNewUser.email}
                            value={requestNewUser.email}
                            // onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            //variant="outlined"
                            InputLabelProps={{shrink: true}}
                            />
                    </div>

                    <div className={classes.cardRow}>
                        <TextField
                            label="Position:"
                            required
                            placeholder="Position"
                            id="position"
                            name="position"
                            className={classes.cardItem}
                            error={requestNewUser.position !== undefined && !requestNewUser.position}
                            value={requestNewUser.position}
                            onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            //variant="outlined"
                            InputLabelProps={{shrink: true}}
                            />                                
                        <TextField
                            label="Company:"
                            required
                            placeholder="Company"
                            id="company"
                            name="company"
                            className={classes.cardItem}
                            error={requestNewUser.company !== undefined && !requestNewUser.company}
                            value={requestNewUser.company}
                            onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            //variant="outlined"
                            InputLabelProps={{shrink: true}}
                            />
                        {/* <TextField
                            label="Country:"
                            required
                            placeholder="Country"
                            id="location"
                            name="location"
                            className={classes.cardItem}
                            error={requestNewUser.location !== undefined && !requestNewUser.location}
                            value={requestNewUser.location}
                            onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            //variant="outlined"
                            InputLabelProps={{shrink: true}}
                            /> */}
                    </div>

                    {/* <div className={classes.cardRow}>
                        <TextField
                            label="Address:"
                            required
                            placeholder="Address"
                            id="address"
                            name="address"
                            className={classes.cardItem}
                            error={requestNewUser.address !== undefined && !requestNewUser.address}
                            value={requestNewUser.address}
                            onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            //variant="outlined"
                            InputLabelProps={{shrink: true}}
                            />
                    </div> */}

                    {/* <div className={classes.cardRow}>
                        <TextField
                            label="ZipCode:"
                            required
                            placeholder="ZipCode"
                            id="zipCode"
                            name="zipCode"
                            className={classes.cardItem}
                            error={requestNewUser.zipCode !== undefined && !requestNewUser.zipCode}
                            value={requestNewUser.zipCode}
                            onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            //variant="outlined"
                            InputLabelProps={{shrink: true}}
                            />
                        <TextField
                            label="City:"
                            required
                            placeholder="City"
                            id="city"
                            name="city"
                            className={classes.cardItem}
                            error={requestNewUser.city !== undefined && !requestNewUser.city}
                            value={requestNewUser.city}
                            onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            //variant="outlined"
                            InputLabelProps={{shrink: true}}
                            />
                    </div> */}

                    <div className={classes.cardRow}>
                        <TextField
                            label="Country:"
                            // required
                            placeholder="Country"
                            id="country"
                            name="country"
                            className={classes.cardItem}
                            // error={requestNewUser.country !== undefined && !requestNewUser.country}
                            value={requestNewUser.country}
                            onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            //variant="outlined"
                            InputLabelProps={{shrink: true}}
                            />
                        <TextField
                            label="Phone:"
                            // required
                            placeholder="Phone"
                            id="phoneNumber"
                            name="phoneNumber"
                            className={classes.cardItem}
                            // error={requestNewUser.phoneNumber !== undefined && !requestNewUser.phoneNumber}
                            value={requestNewUser.phoneNumber}
                            onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            //variant="outlined"
                            InputLabelProps={{shrink: true}}
                            />
                    </div>

                    <div className={classes.cardRow}>
                        {/* <TextField
                            select
                            label="User Type:"
                            required
                            placeholder="User Type"
                            id="type"
                            name="type"
                            className={classes.cardItem}
                            error={requestNewUser.type !== undefined && !requestNewUser.type}
                            value={requestNewUser.type}
                            onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            //variant="outlined"
                            InputLabelProps={{shrink: true}}>
                                {   
                                    userTypes.map((type) => (
                                        <MenuItem key={type.value} value={type.value}>
                                            {type.text}                                                
                                        </MenuItem>
                                    ))                                    
                                }
                        </TextField> */}
                        <TextField
                            select
                            label="Default Language:"
                            required
                            placeholder="Default Language"
                            id="language"
                            name="language"
                            className={classes.cardItem}
                            error={requestNewUser.language !== undefined && !requestNewUser.language}
                            value={requestNewUser.language}
                            onChange={handleInputChange}                            
                            fullWidth
                            //margin="dense"
                            //variant="outlined"
                            InputLabelProps={{shrink: true}}>
                                <MenuItem value="pt-BR">Portuguese</MenuItem>                                    
                                <MenuItem value="en">English</MenuItem>                                    
                                <MenuItem value="es">Spanish</MenuItem>                                    
                        </TextField>
                        <div className={classes.cardItem}>&nbsp;</div>
                    </div>

                    <div className={classes.cardRow}></div>
                </div>
                <div className={classes.cardContentUserData}>
                    <div className={classes.cardRow} style={{flexDirection: 'column'}}>
                        <span className={classes.cardTitle}>Applications</span>
                        <span className={classes.cardTitle} style={{fontSize: '14px'}}>Please manage permissions for {requestNewUser.firstName}</span>
                    </div>
                    {
                        requestNewUser.profiles.filter(profile => profile.applicationId === currentApp.id).map(profile => (
                            dashboardData.filter(app => app.id === profile.applicationId).map(app => (
                                <div key={profile.id} className={classes.cardRow} style={{margin: '6px 16px'}}>
                                    <div className={classes.cardApp}>
                                        <div style={{margin: '10px'}}>
                                            {/* <Checkbox checked={profile.checked} 
                                                // onChange={handleChange}
                                                name="checkedB" color="primary" /> */}
                                            { app.name }                            
                                        </div>
                                        
                                        <TextField
                                            select
                                            label="User Profile:"
                                            required
                                            placeholder="User Profile"
                                            id={'profile-'+profile.id}
                                            name={'profile-'+profile.id}
                                            className={classes.cardItem}
                                            // error={requestNewUser.'type !== undefined && !requestNewUser.type}
                                            value={profile.id}
                                            onChange={handleProfileInputChange(profile)}                            
                                            fullWidth
                                            //margin="dense"
                                            //variant="outlined"
                                            InputLabelProps={{shrink: true}}>
                                                {   
                                                    app.profiles.map((appProfile) => (
                                                        <MenuItem key={appProfile.id} value={appProfile.id}>
                                                            {appProfile.label}                                                
                                                        </MenuItem>
                                                    ))                                    
                                                }
                                        </TextField>
                                    </div>
                                </div>
                            ))
                        ))                                    
                    }
                    <div className={classes.cardRow} style={{flexDirection: 'column', marginTop: '26px'}}>
                        <span className={classes.cardTitle} style={{fontSize: '14px'}}>Other applications for this user</span>
                    </div>
                    {
                        requestNewUser.othersApps.map(app => (
                            <div key={'other-app-'+app.id} className={classes.cardRow} style={{margin: '6px 16px'}}>
                                <div className={classes.cardOtherApp}>
                                    <div>
                                        { app.isMobile && <img className={classes.cardIcon} src={MobileIcon} alt="Mobile"/> }
                                        { app.isWeb && <img className={classes.cardIcon} src={DesktopIcon} alt="Desktop"/> }
                                    </div>                                        
                                    <span>{app.label}</span>
                                </div>
                            </div>
                        ))                                    
                    }
                </div>
            </div>
        </DialogContent>
        <DialogActions>
            <Button color="primary" style={{width: '100px'}} onClick={handleRequestNewUserClose}>
                Close   
            </Button>
            <Button color="primary" style={{width: '100px'}} onClick={handleRequestNewUserDeny}>
                Deny
            </Button>
            <Button variant="contained" color="primary" style={{width: '100px'}} onClick={handleRequestNewUserApply}>
                Apply
            </Button>
        </DialogActions>
    </Dialog>, [currentApp, requestNewUser, isLoading]);


    return (
        <Container className={classes.root} maxWidth="xl">
            <Grid container spacing={0} className={classes.header}>
                <span className={classes.title}>Welcome {currentUser ? currentUser.firstName : ''}!</span>
                <div className={classes.toolbar}>
                    { currentUser?.roles?.APPLICATION && <Button variant="contained" className={classes.gradientButton} style={{width: 150, marginRight: 5}} onClick={handleApplications} >
                        Applications
                    </Button> }
                    { currentUser?.roles?.PROFILE && <Button variant="contained" className={classes.gradientButton} style={{width: 150, marginRight: 5}} onClick={handleProfiles} >
                        Profiles
                    </Button> }
                    { currentUser?.roles?.USER && <Button variant="contained" className={classes.gradientButton} style={{width: 150, marginRight: 5}} onClick={handleUsers} >
                        Users
                    </Button> }
                    { currentUser?.roles?.SERVICE && <Button variant="contained" className={classes.gradientButton} style={{width: 150, marginRight: 5}} onClick={handleServices} >
                        Service Account
                    </Button> }
                    { currentUser?.roles?.REPORT && <Button variant="contained" className={classes.gradientButton} style={{width: 150, marginRight: 5}} onClick={handleView} >
                        { view }
                    </Button> }
                </div>
            </Grid>
            { view === 'Reports' ? renderDashboard : renderReport }

            { renderRequestNewUserList }
            { renderRequestNewUser }

            <DropzoneDialogBase
                dialogTitle="Upload Picture"
                acceptedFiles={['image/*']}
                fileObjects={pictureObjects}
                cancelButtonText={"Cancel"}
                submitButtonText={"Submit"}
                maxFileSize={6291456}
                filesLimit={1}
                open={openPictureDialog}
                onAdd={newFileObjs => {
                    console.log('onAdd', newFileObjs);
                    setPictureObjects(newFileObjs);
                }}
                onDelete={deleteFileObj => {
                    console.log('onDelete', deleteFileObj);
                    setPictureObjects([]);
                }}
                onClose={() => setOpenPictureDialog(false)}
                onSave={handleUploadUserPicture}
                showPreviews={false}
                showFileNamesInPreview={false}
                showPreviewsInDropzone={true}
            />

            <LoadingOverlay open={isLoading} />
        </Container>
    );
};

export default Home;
